import { httpUrl } from "./httpUrl";

let baseUrl = `${httpUrl.host}/gy-apartment`;

let api = {
  // 客户主数据分页
  getCustomerPage: `${baseUrl}/customer/getPage`,

  // 客户主数据同步
  getCustomerSync: `${baseUrl}/customer/sync`,

  // 基础信息分页
  getDaliDictItemPage: `${baseUrl}/daliDictItem/getPage`,

  // 添加基础信息
  addDaliDictItem: `${baseUrl}/daliDictItem/add`,

  // 修改基础信息
  updateDaliDictItem: `${baseUrl}/daliDictItem/update`,

  // 删除基础信息
  deleteDaliDictItem: `${baseUrl}/daliDictItem/deleteByCodes`,

  // 利润/成本中心分页
  getDaliCostCenterPage: `${baseUrl}/daliCostCenter/getPage`,

  // 添加利润/成本中心
  addDaliCostCenter: `${baseUrl}/daliCostCenter/add`,

  // 修改利润/成本中心
  updateDaliCostCenter: `${baseUrl}/daliCostCenter/update`,

  // 删除利润/成本中心
  deleteDaliCostCenter: `${baseUrl}/daliCostCenter/deleteByCodes`,

  //获取住户查询列表
  getDaliDictItemList: `${baseUrl}/daliDictItem/list`,

  // 场景模板分页
  getScenesConfigPage: `${baseUrl}/scenesConfig/getPage`,

  // 添加场景模板
  addScenesConfig: `${baseUrl}/scenesConfig/add`,

  // 修改场景模板
  updateScenesConfig: `${baseUrl}/scenesConfig/update`,

  // 删除场景模板
  deleteScenesConfig: `${baseUrl}/scenesConfig/deleteByCodes`,

  // 导入场景模板
  importTemplate: `${baseUrl}/scenesConfig/importTemplate`,

  //获取所有场景列表
  getScenesList: `${baseUrl}/scenesConfig/scenesList`
};

export { api };



// WEBPACK FOOTER //
// ./src/view/api/Group.js